import React, { useState } from 'react';
import video1 from '../../assests/vdo/v1.mp4';
import video2 from '../../assests/vdo/v2.mp4';
import video3 from '../../assests/vdo/v3.mp4';
import video4 from '../../assests/vdo/v4.mp4';
import video5 from '../../assests/vdo/v5.mp4';
import video6 from '../../assests/vdo/v6.mp4';

const videos = [
  video1, video2, video3, video4, video5,
  video6,
];

const VdoGallery = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openModal = (index) => {
    setSelectedIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedIndex(null);
  };

  const showPrevious = () => {
    setSelectedIndex(prev => (prev > 0 ? prev - 1 : videos.length - 1));
  };

  const showNext = () => {
    setSelectedIndex(prev => (prev < videos.length - 1 ? prev + 1 : 0));
  };

  return (
    <section id="video-gallery" className="w-full py-20">
      <div className="flex justify-center items-center text-center mb-8">
        <h2 className="text-4xl font-semibold">Video Gallery</h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-6 px-2">
        {videos.map((src, index) => (
          <div
            key={index}
            className="video-card bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-transform duration-200 hover:scale-105"
            onClick={() => openModal(index)}
            style={{ height: '300px' }}
          >
            <video
              className="w-full h-full object-cover"
              muted
              loop
              preload="metadata"
            >
              <source src={src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && selectedIndex !== null && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 p-4"
          onClick={closeModal} // clicking outside modal closes it
        >
          <div
            className="relative bg-white rounded-lg shadow-lg overflow-hidden max-w-lg w-full max-h-[80vh] flex flex-col"
            onClick={(e) => e.stopPropagation()} // prevent modal click from closing
          >
            <video
              className="w-full h-auto max-h-[60vh] object-contain bg-black"
              src={videos[selectedIndex]}
              controls
              autoPlay
            />

            {/* Controls container */}
            <div className="flex justify-between items-center p-2 bg-gray-100">
              {/* Prev button */}
              <button
                onClick={showPrevious}
                className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded"
                aria-label="Previous video"
              >
                ◀ Prev
              </button>

              {/* Close button */}
              <button
                onClick={closeModal}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                aria-label="Close video modal"
              >
                Close ✕
              </button>

              {/* Next button */}
              <button
                onClick={showNext}
                className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded"
                aria-label="Next video"
              >
                Next ▶
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default VdoGallery;
